export default "__VITE_ASSET__Dql0GbeS__"